import React from "react";
import { AppStoreButton } from "./AppStoreButton.tsx";

export const CTASection: React.FC = () => {
  return (
    <section className="py-40 px-6 relative bg-zinc-900 overflow-hidden flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent" />

      <div className="relative z-10 text-center max-w-4xl">
        <h2 className="text-5xl md:text-8xl font-heading font-bold text-white mb-8 leading-[0.9]">
          Ready to see <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-primary/80 to-white">
            Your Impact?
          </span>
        </h2>
        <p className="text-xl text-zinc-400 mb-12 font-light max-w-2xl mx-auto">
          Discover your blindspots. Unlock your potential.
        </p>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <AppStoreButton variant="ios" />
          <AppStoreButton variant="android" />
        </div>
      </div>
    </section>
  );
};
